export const skills: string[] = [
  'JavaScript',
  'TypeScript',
  'React',
  'NextJs',
  'Mobx',
  'HTML',
  'CSS',
  'SCSS',
  'JSON',
  'Git',
  'GitHub',
  'Vercel',
  'NPM',
  'Yarn',
  'Jest',
  'ESLint',
  'StyleLint',
  'Webpack',
  'Figma',
  'AppVeyor',
  'Adobe Photoshop' 
]